/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Agent_VarietyInputs */

const en_us2_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer added it for variety`)
};

const pt_br2_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu personal colocou para variar`)
};

const es_419_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador lo agregó para variar`)
};

const pt_pt2_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador pô-lo para variar`)
};

const fr_fr2_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté par ton coach pour varier`)
};

const de_de2_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach hat sie für Abwechslung hinzugefügt`)
};

const it_it2_prescription_reason_agent_variety = /** @type {(inputs: Prescription_Reason_Agent_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach l'ha aggiunto per variare`)
};

/**
* | output |
* | --- |
* | "Your trainer added it for variety" |
*
* @param {Prescription_Reason_Agent_VarietyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_agent_variety = /** @type {((inputs?: Prescription_Reason_Agent_VarietyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Agent_VarietyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_agent_variety(inputs)
	if (locale === "es-419") return es_419_prescription_reason_agent_variety(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_agent_variety(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_agent_variety(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_agent_variety(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_agent_variety(inputs)
	return en_us2_prescription_reason_agent_variety(inputs)
});
export { prescription_reason_agent_variety as "prescription.reason.agent_variety" }